import { LoadingButton } from '@mui/lab';
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import { LANGUAGE, PUSH_NOTIFICATION_TYPE } from '../../constants';
import { PushNotificationType } from '../../enum';
import { useAppDispatch, useAppSelector } from '../../store';
import { createPushNotificationManagement } from '../../store/pushNotificationManagement/api';
import { reset as resetPushNotificationManagement } from '../../store/pushNotificationManagement/pushNotificationManagementSlice';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const NotificationFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  const dispatch = useAppDispatch();
  const { count } = useAppSelector((state) => state.pushNotificationManagement);

  const handleGetCountUser = async () => {
    if (values?.type) {
      if (values?.type === PushNotificationType.corporate) {
        await dispatch(
          createPushNotificationManagement({
            type: values.type,
            countOnly: true,
          })
        ).unwrap();
      }
      if (values?.type === PushNotificationType.individual) {
        await dispatch(
          createPushNotificationManagement({
            type: values.type,
            countOnly: true,
          })
        ).unwrap();
      }
      if (values?.type === PushNotificationType.language) {
        await dispatch(
          createPushNotificationManagement({
            type: values.type,
            countOnly: true,
            ...(values.language && {
              language: values?.language,
            }),
          })
        ).unwrap();
      }
      if (values?.type === PushNotificationType.allUsers) {
        await dispatch(
          createPushNotificationManagement({
            type: values.type,
            countOnly: true,
          })
        ).unwrap();
      }
    }
  };

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        dispatch(resetPushNotificationManagement());
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Notification</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControl
                fullWidth
                error={Boolean(touched?.type && errors?.type)}
              >
                <InputLabel>{'Type'}</InputLabel>
                <Select
                  name='type'
                  labelId='type'
                  id='type'
                  value={values.type}
                  label={'Type'}
                  onChange={(e) => setFieldValue('type', e.target.value)}
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {PUSH_NOTIFICATION_TYPE?.map((type) => (
                    <MenuItem
                      key={type.value}
                      value={type.value}
                    >
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
                {Boolean(touched.type && errors.type) && (
                  <FormHelperText>{errors?.type}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='title'
                name='title'
                label='Title'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.title}
                error={Boolean(errors.title && touched.title)}
                helperText={
                  Boolean(errors.title && touched.title) && errors.title
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='message'
                name='message'
                label='Message'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.message}
                error={Boolean(errors.message && touched.message)}
                helperText={
                  Boolean(errors.message && touched.message) && errors.message
                }
              />
            </Grid>

            {/* {values?.type === PushNotificationType.location && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <AutoComplete
                  key={`toC-${values?.locationId}`}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                    } else if (newValue) {
                      setFieldValue('locationId', newValue.id);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (!newInputValue) {
                      setFieldValue('locationId', '');
                    }
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>{option.labelEn}</li>
                  )}
                  getOptionLabel={(option) => option.labelEn}
                  error={Boolean(touched.locationId && errors.locationId)}
                  helperText={
                    Boolean(touched.locationId && errors.locationId)
                      ? errors.locationId
                      : ''
                  }
                  fetchFunction={onScrollFetchLocation}
                  label={'Select Location'}
                  loading={isLocationLoading}
                  options={uniqueLocationData}
                  searchFunction={searchLocation}
                  value={
                    uniqueLocationData?.filter(
                      (location) => location.id === values.locationId
                    )?.[0] || null
                  }
                />
              </Grid>
            )} */}

            {values?.type === PushNotificationType.language && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <FormControl
                  fullWidth
                  error={Boolean(touched?.language && errors?.language)}
                >
                  <InputLabel>{'Language'}</InputLabel>
                  <Select
                    name='language'
                    labelId='language'
                    id='language'
                    value={values.language}
                    label={'Language'}
                    onChange={(e) => setFieldValue('language', e.target.value)}
                    MenuProps={{
                      style: {
                        maxHeight: 400,
                      },
                    }}
                  >
                    {LANGUAGE?.map((type) => (
                      <MenuItem
                        key={type.value}
                        value={type.value}
                      >
                        {type.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {Boolean(touched.language && errors.language) && (
                    <FormHelperText>{errors?.language}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            )}
            {count !== 0 && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                Number of users: {count}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleGetCountUser}
            variant='contained'
          >
            {'Calculate users'}
          </Button>
          <Button
            onClick={() => {
              resetForm();
              dispatch(resetPushNotificationManagement());
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default NotificationFormModal;
